<template>
  <div class="pitanje-single">
    <span class="tag">{{ tag }}</span>

    <p class="title">
      {{ question && question.question }}
    </p>

    <!-- <img class="img" v-if="question.image" :src="question.image" alt="Question image"/> -->

    <div class="answers">
      <template v-for="(answer, answerIndex) in answers">
          <ProbniOdgovorSingle :answer="answer" v-bind:key="answerIndex" v-model="questionAnswerId" :canClick="!lockedIn"> </ProbniOdgovorSingle>
      </template>
      <span></span>
    </div>

    <p class="desc">
      <span>Napomena: </span>
      Kada vrijeme za odgovor istekne, sustav će se sam prebaciti na sljedeće pitanje.
    </p>

    <!-- <div class="logo" Ovdje je bio background image, uklonjen je></div> -->

    <div class="button" @click.prevent="lockInAnswer()">
        <a href="#" class="button-1" v-bind:class="{'red': !lockedIn, 'blue': lockedIn, 'no-arrow': lockedIn}"><span>{{ lockedIn?'Odgovor zaključan':'Zaključaj odgovor' }}</span></a>
    </div>
  </div>
</template>

<script>
import { QuestionUtils } from '../utils/questionUtils.js'
import ProbniOdgovorSingle from './ProbniOdgovorSingle.vue'

export default {
    name: 'probno-pitanje-single',
    props: {
        questions: {}
    },
    data: function () {
        return {
            lockedIn: false,
            questionAnswerId: null
        }
    },
    components: { ProbniOdgovorSingle },
    methods: {
        lockInAnswer () {
            this.lockedIn = true
        },
        sendAnswer (questionKey) {
            let answer = {
                questionKey: questionKey,
                answerIndex: this.questionAnswerId
            }
            this.$store.state.exampleRoundAnswers.push(answer)
            this.questionAnswerId = null
            this.lockedIn = false
        }
    },
    computed: {
        questionId () {
            return this.$route.params.id
        },
        tag () {
            try {
                return QuestionUtils.getTypeText(this.question.type)
            } catch (error) {}
            return ''
        },
        question () {
            try {
                return this.questions[this.questionId]
            } catch (error) { }
            return {}
        },
        answers () {
            try {
                return this.question.answers
            } catch (error) { }
            return {}
        }
    },
    mounted: function () {
        try {
            if (this.questions[this.questionId] === undefined) {
                this.$router.push('/home')
            }
        } catch (error) {
            this.$router.push('/home')
        }
    }
}
</script>

<style lang="scss" scoped>
.pitanje-single {
    position: relative;
    box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
    background-color: #fff;
    border-radius: 6px;
    padding: 46px 14px 16px;
    text-align: left;

    .tag {
        box-shadow: 0px 9px 10px 0px rgba(255,0,92,0.25);
        background: linear-gradient(135deg, rgba(255,0,132,1) 0%, rgba(255,0,29,1) 100%);
        font-family: "axiforma";
        position: absolute;
        top: 16px;
        left: 14px;
        display: block;
        border-radius: 6px;
        min-width: 50px;
        font-size: 10px;
        text-align: center;
        color: #fff;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 1px;
        padding: 5px 10px 4px;
        background-color: #08305d;
    }
    .title {
        font-family: "mPlus";
        font-size: 20px;
        letter-spacing: -.2px;
        line-height: 24px;
        color: #000;
        margin-bottom: 16px;
    }
    .desc {
        font-family: "axiforma";
        font-size: 12px;
        line-height: 18px;
        color: #adadae;
        letter-spacing: .5px;
        margin-bottom: 40px;

        span {
            color: #3d85ce;
        }
    }
    .img {
        position: relative;
        width: calc(100% + 28px);
        display: block;
        height: auto;
        margin-bottom: 26px;
        left: -14px;
    }
    .answers {
        margin-bottom: 20px;
        font-family: "mPlus";
        font-size: 20px;
        letter-spacing: -.2px;
        color: #000;
    }
    .logo {
        display: block;
        width: 111px;
        height: 42px;
        background-position: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        margin: auto;
    }
    .button {
        .button-1 {
            margin: 0 auto;
            position: relative;
            display: block;
            min-width: 200px;
            width: 80%;
        }
    }
}
@media only screen and (max-width: 380px) {
    .pitanje-single {
        .title {
            font-size: 18px;
            line-height: 20px;
        }
        .answers {
            font-size: 16px;
            line-height: 18px;
        }
    }
}
</style>
